import { Route } from "react-router-dom";
import { DynamicFormPage } from "../components/dynamic-questionnaire/dynamic-form-page";
import { routes } from "./routes";
import { DynamicQuestionnaireData } from "@shared/types";

export const DynamicFormPageRoutes = ({
  questionnaireData,
  routeAfterLastPage = routes.questionnaire.almostDone,
}: {
  questionnaireData: DynamicQuestionnaireData;
  routeAfterLastPage?: string;
}) =>
  Object.entries(questionnaireData).map(([path, pageData], index) => {
    return (
      <Route
        key={index}
        path={path}
        element={
          <DynamicFormPage
            key={index}
            nextRoute={
              index < Object.keys(questionnaireData).length - 1
                ? Object.keys(questionnaireData)[index + 1]
                : routeAfterLastPage
            }
            elements={pageData.elements}
            showDivider={pageData.showDivider}
            submitButton={pageData.button}
          />
        }
      />
    );
  });
